<template>
  <div class="docker-server">
    <iframe name="iframeChild" id="iframeChild" v-bind:src="getPageUrl"
            frameborder="0" scrolling="auto" ref="iframeDom">
    </iframe>
  </div>
</template>

<script>
  import { epecMallUrl } from '../../api/config';

  export default {
    name: 'server',
    data() {
      return {
        getPageUrl: epecMallUrl + '/provideNesting/addressManagement'
      };
    },
    mounted() {
    }
  };
</script>

<style lang="scss" scoped>
  /** iframe样式 */
  #iframeChild {
    width: 100%;
    height: calc(100vh - 125px);
  }
</style>